module.exports = __webpack_public_path__ + "static/envelope-body-0ec42b299ad37cecd53e5977914879da.png";